import {USER_INFO} from "../config/config";

export function hasAccess(restrictedRoles: string[]): boolean {
  const userRoles: string[] = JSON.parse(localStorage.getItem(USER_INFO) as string).roles;

  // Lista de todos los roles válidos del sistema
  const ROLESTOTALES: string[] = [
    "ROLE_COMMS_USER",
    "ROLE_COUNTRY_ADMIN",
    "ROLE_COUNTRY_PROCESS",
    "ROLE_GLOBAL_ADMIN",
    "ROLE_REGION_ADMIN",
    "ROLE_SYSADMIN",
    "ROLE_GUEST",
    "ROLE_USER",
  ];

  // 1. Filtrar los roles del usuario que son válidos
  const validUserRoles = userRoles.filter(role => ROLESTOTALES.includes(role));

  // 2. Quitar los que están restringidos
  const rolesConAcceso = validUserRoles.filter(role => !restrictedRoles.includes(role));

  // 3. Si queda alguno, significa que el usuario tiene al menos un rol permitido
  return rolesConAcceso.length > 0;
}